import React from "react"
import PropTypes from "prop-types"
import { toggle, setAll } from "../../redux/selection"
import { showSelectedOnly } from "../../redux/settings"
import { setParam, fetch } from "../../redux/query"
import store from "../../redux"
import { connect } from "react-redux"
import "./Dashboard.less"
import ReactJson from "react-json-view"
import { withRouter } from "../../lib/withRouter"
import ViewUMHeader from "./ViewUMHeader"
import Header2 from "../Header2"
import { getQuickSightUrl, postResource, getUserRole } from "../../lib"
import UMSidebar from "./UMSidebar"
import ConfirmPopover from "./ConfirmPopover"
import {
    APP_TAB_PERMISSIONS,
    APP_TAB_PERMISSION_IDS,
    isUserAdmin
} from "../../lib/appPermissions"

export class UserManagement extends React.Component {
    static propTypes = {
        query: PropTypes.object,
        selection: PropTypes.object,
        location: PropTypes.object,
        settings: PropTypes.object,
        urlParams: PropTypes.object,
        dispatch: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.state = {
            usersList: null,
            rolesList: null,
            loading: false,
            error: null,
            activeTab: "users",
            isSidebarOpen: false,
            sidebarTitle: "",
            sidebarView: "",
            selectedUser: null,
            formData: {},
            confirmPopover: {
                show: false,
                target: null,
                user: null,
                index: null,
                newStatus: null
            }
        };
    }

    /** Callback to handle tab changes from ViewHeader */
    handleTabChange = (tabName) => {
        this.setState({ activeTab: tabName });
        this.props.dispatch(setParam("_resource", tabName));
    };

    componentDidMount() {
        // User Management is Admin-group only (not scope-based)
        if (!isUserAdmin(getUserRole())) {
            this.props.router.navigate("/patient-list");
            return;
        }

        const query = new URLSearchParams(this.props.location.search);

        // CHECK REDIRECT TABS
        const _tab = query.get("_tab");
        if (["demographics", "conditions", "tags"].includes(_tab)) {
            query.delete("_resource");
            const clean = query.toString() ? `?${query.toString()}` : "";
            this.props.router.navigate(`/patient-list${clean}`);
            return;
        }

        // SET ACTIVE TAB
        const tab = query.get("_resource") || "users";
        this.setState({ activeTab: tab }, () => {
            this.fetchDataForTab(tab);
        });
    }

    componentDidUpdate(prevProps, prevState) {
        // Check if activeTab changed
        if (prevState.activeTab !== this.state.activeTab) {
            this.fetchDataForTab(this.state.activeTab);
        }
    }

    fetchDataForTab = (tab) => {
        switch (tab) {
            case "users":
                this.fetchUsersData();
                break;
            case "roles":
                this.fetchRolesData();
                break;
        }
    };

    fetchUsersData = async () => {
        try {
            this.setState({ loading: true, error: null });

            const apiUrl = `${this.props.settings.server.baseUrl}/usermanagement/users`;
            console.log("API URL:", apiUrl);

            const data = await getQuickSightUrl({
                url: apiUrl,
                server: this.props.settings.server,
            });

            if (data) {
                this.setState({
                    usersList: data || [],
                    loading: false,
                });
            }

        } catch (error) {
            console.error("Failed to load data:", error);
            this.setState({ error: error.message, loading: false });
        }
    };

    fetchRolesData = async () => {
        try {
            this.setState({ loading: true, error: null });

            const apiUrl = `${this.props.settings.server.baseUrl}/usermanagement/groups`;

            const data = await getQuickSightUrl({
                url: apiUrl,
                server: this.props.settings.server,
            });

            if (data) {
                const transformed = data
                    .map(r => ({
                        ...r,
                        // split description into array
                        permissions: r.description
                            ? r.description.split(",").map(p => p.trim())
                            : [],

                        isDirty: false
                    }))
                    // sort by groupName asc
                    .sort((a, b) => a.groupName.localeCompare(b.groupName));

                this.setState({ rolesList: transformed, loading: false });
            }

        } catch (error) {
            console.error("Failed to load QuickSight data:", error);
            this.setState({ error: error.message, loading: false });
        }
    };

    handleServiceProviderChange = async (formData) => {
        const selectedProvider = formData.provider;
        try {
            const apiUrl = `${this.props.settings.server.baseUrl}/referral/create/loginDetails`;
            const userPostData = {
                username: formData.username,
                email: formData.email,
                serviceProviderId: formData.provider
            };
            const response = await postResource({
                url: apiUrl,
                data: userPostData,
                dataType: "text"
            });

            console.log("API Response:", response);
        } catch (err) {
            console.error("API Error:", err);
        }
    }

    handleFormSubmit = async (formData, type) => {
        console.log("Form submitted with data:", formData, type);
        if (type === 'user') {
            // Handle user form submission logic here
            let userPostData = {
                username: formData.username,
                email: formData.email,
                familyname: formData.firstName,
                givenname: formData.lastName,
                groups: [formData.group] || []
            };
            console.log("User POST Data:", userPostData);

            try {
                const apiUrl = `${this.props.settings.server.baseUrl}/usermanagement/user`;

                const response = await postResource({
                    url: apiUrl,
                    data: userPostData,
                    dataType: "text"
                });

                console.log("API Response:", response);

                // ✅ SUCCESS: clear selected files
                // this.setState({ selectedFiles: [] });

                if (formData.provider) {
                    await this.handleServiceProviderChange(formData);
                }
                // ✅ REFRESH DATA
                this.fetchUsersData();
                this.setState({ isSidebarOpen: false });
            } catch (err) {
                console.error("API Error:", err);
            }

        } else if (type === 'userEdit') {
            let assignGroupPostData = {
                username: this.state.selectedUser.username,
                groups: [formData.group] || []
            };
            let removeGroupPostData = {
                username: this.state.selectedUser.username,
                groups: this.state.selectedUser.groups || []
            };
            console.log("User POST Data:", assignGroupPostData, removeGroupPostData);

            try {
                const response = await postResource({
                    url: `${this.props.settings.server.baseUrl}/usermanagement/users/remove-groups`,
                    data: removeGroupPostData,
                    dataType: "text"
                });

                if (response) {
                    const assignResponse = await postResource({
                        url: `${this.props.settings.server.baseUrl}/usermanagement/users/assign-groups`,
                        data: assignGroupPostData,
                        dataType: "text"
                    });

                    if (assignResponse) {
                        if (formData.provider) {
                            await this.handleServiceProviderChange(formData);
                        }
                        this.fetchUsersData();
                        this.setState({ isSidebarOpen: false });
                    }
                }

            } catch (err) {
                console.error("API Error:", err);
            }
        } else if (type === 'group') {
            // Handle group form submission logic here
            let groupPostData = {
                groupName: formData.roleName,
                scopes: formData.scopes || []
            };
            console.log("Group POST Data:", groupPostData);

            try {
                const apiUrl = `${this.props.settings.server.baseUrl}/usermanagement/group`;

                const response = await postResource({
                    url: apiUrl,
                    data: groupPostData,
                    dataType: "text"
                });

                console.log("API Response:", response);

                // ✅ REFRESH DATA
                this.fetchRolesData();
                this.setState({ isSidebarOpen: false });
            } catch (err) {
                console.error("API Error:", err);
            }
        }
    }

    render() {
        return (
            <div className="page">
                <div className="app-header">
                    <Header2
                        query={this.props.query}
                        settings={this.props.settings}
                        location={this.props.location}
                        urlParams={this.props.urlParams}
                    />

                    <ViewUMHeader
                        query={this.props.query}
                        settings={this.props.settings}
                        location={this.props.location}
                        urlParams={this.props.urlParams}
                        activeTab={this.state.activeTab}
                        onTabChange={this.handleTabChange}
                    />
                </div>

                <div className="patient-search-results">
                    {this.renderTabContent()}
                </div>

                {/* Sidebar */}
                {this.state.isSidebarOpen && (
                    <UMSidebar
                        isSidebarOpen={!!this.state.isSidebarOpen}
                        onClose={() => this.setState({ isSidebarOpen: false })}
                        settings={this.props.settings}
                        title={this.state.sidebarTitle}
                        sidebarView={this.state.sidebarView}
                        onSave={(formData, type) => {
                            this.handleFormSubmit(formData, type);
                        }}
                        selectedUser={this.state.selectedUser}
                    />
                )}

                <ConfirmPopover
                    show={this.state.confirmPopover.show}
                    target={this.state.confirmPopover.target}
                    message={`Are you sure you want to ${this.state.confirmPopover.newStatus ? "activate" : "deactivate"
                        } this user?`}
                    onConfirm={this.confirmStatusChange}
                    onCancel={this.cancelStatusChange}
                />


            </div>
        )
    }

    renderTabContent() {
        const { activeTab } = this.state;

        switch (activeTab) {
            case "users":
                return this.renderUsersContent();
            case "roles":
                return this.renderRolesContent();
        }
    }

    handleStatusChange = (user, index, event) => {
        const newStatus = !this.state.usersList[index].enable;

        this.setState({
            confirmPopover: {
                show: true,
                target: event.target,
                user,
                index,
                newStatus
            }
        });
    };

    confirmStatusChange = async () => {
        const { user, index, newStatus } = this.state.confirmPopover;
        console.log("Confirming status change for user:", user, "to", newStatus);

        try {
            const apiUrl = `${this.props.settings.server.baseUrl}/usermanagement/users/${newStatus ? 'enable' : 'disable'}/${user.username}`;

            const data = await getQuickSightUrl({
                url: apiUrl,
                server: this.props.settings.server,
                dataType: "text"
            });

            this.setState({
                confirmPopover: { show: false }
            });
            this.fetchUsersData();
        } catch (err) {
            console.error(err);
            this.setState({ confirmPopover: { show: false } });
        }
    };

    cancelStatusChange = () => {
        this.setState({
            confirmPopover: { show: false }
        });
    };

    handleSidebar(open, title, view, user = {}) {
        this.setState({ isSidebarOpen: open, sidebarTitle: title, sidebarView: view, selectedUser: user });
    }

    renderUsersContent() {
        const { loading, error, claimListResult, currentPage, hasNextPage, pageSize } = this.state;
        const { usersList } = this.state;

        if (loading) {
            return <div className="patient-search-loading">
                <i className="fa fa-spinner spin" /> Loading. Please wait...
            </div>;
        }

        if (error) {
            return <p className="text-danger">Error: {error}</p>;
        }

        const searchHeader = (
            <div className="panel-default">
                <div className="panel-heading" style={{ padding: "5px 15px" }}>
                    <div className="row d-flex align-items-center">
                        <div className="col-xs-4">
                            <b className="text-primary">
                                <i className="fa fa-address-card-o" /> User List
                            </b>
                        </div>
                        <div className="col-xs-8">
                            <div className="row">
                                <div className="col-md-3 pull-right text-right">
                                    <button
                                        className="btn btn-primary btn-sm"
                                        onClick={() => this.handleSidebar(true, "New User", "user")}
                                    >
                                        <i className="fa fa-plus" />
                                        &nbsp;New User
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        if (!usersList || usersList.length === 0) {
            return (
                <>
                    {searchHeader}
                    <p>No user data available.</p>
                </>
            );
        }

        return (
            <>
                <div className="tab-content-wrapper" style={{ marginBottom: "2.5rem" }}>
                    {searchHeader}
                    <div className="panel-default">

                        <div className="table-responsive">
                            <table className="table table-condensed table-hover table-striped table-bordered">
                                <thead>
                                    <tr>
                                        <th>Username</th>
                                        <th>Email</th>
                                        <th className="text-center">Roles</th>
                                        <th className="text-center">Status</th>
                                        <th className="text-center">Active</th>
                                        <th className="text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.renderUserListRows()}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    renderUserListRows() {
        const { usersList } = this.state;

        if (!usersList || usersList.length === 0) {
            return (
                <tr>
                    <td colSpan="10" className="text-center">No records found</td>
                </tr>
            );
        }

        return usersList.map((user, index) => (
            <tr
                key={index}
                style={{ cursor: "pointer" }}
            >
                <td>{user?.username || "-"}</td>
                <td>{user?.email || "-"}</td>

                {/* Role Badges */}
                <td className="text-center">
                    {user?.groups?.length > 0 ? (
                        user.groups.map((grp, i) => (
                            <span
                                key={i}
                                className="badge"
                                style={{
                                    backgroundColor: "#337ab7",
                                    marginRight: "5px"
                                }}
                            >
                                {grp}
                            </span>
                        ))
                    ) : (
                        "-"
                    )}
                </td>

                <td className="text-center">{user?.userStatus || "-"}</td>

                {/* Checkbox for userStatus */}
                <td className="text-center">
                    <input
                        type="checkbox"
                        style={{ cursor: "pointer" }}
                        checked={user?.enable === true}
                        onChange={(e) => this.handleStatusChange(user, index, e)}
                    />
                </td>

                <td className="text-center">
                    {!user.groups.includes("AgencyUser") && (
                        <span className="text-primary" onClick={() => {
                            this.handleSidebar(true, "Edit User", "userEdit", user);
                        }}>
                            <i className="fa fa-edit"></i>
                        </span>
                    )}
                </td>

            </tr>
        ));
    }

    handlePermissionClick = (role, permission, index) => {
        const rolesList = [...this.state.rolesList];
        let currentRole = { ...rolesList[index] }; // clone row object

        const allPermissions = APP_TAB_PERMISSION_IDS;

        // ----------------------------
        // CASE 1: CLICKING "ALL"
        // ----------------------------
        if (permission === "all") {
            const isAllChecked = currentRole.permissions.includes("all");

            currentRole.permissions = isAllChecked
                ? [] // uncheck all
                : ["all", ...allPermissions]; // check everything

            currentRole.isDirty = true;
        }

        // ----------------------------
        // CASE 2: INDIVIDUAL PERMISSIONS
        // ----------------------------
        else {
            const exists = currentRole.permissions.includes(permission);

            currentRole.permissions = exists
                ? currentRole.permissions.filter(p => p !== permission)
                : [...currentRole.permissions, permission];

            // If all items selected, auto-enable "all"
            const allSelected = allPermissions.every(p =>
                currentRole.permissions.includes(p)
            );

            if (allSelected) {
                currentRole.permissions = ["all", ...allPermissions];
            } else {
                currentRole.permissions = currentRole.permissions.filter(p => p !== "all");
            }

            currentRole.isDirty = true;
        }

        // Update the row in array
        rolesList[index] = currentRole;

        this.setState({ rolesList });
    };

    renderRolesContent() {
        const { loading, error, claimListResult, currentPage, hasNextPage, pageSize } = this.state;
        const { rolesList } = this.state;

        if (loading) {
            return <div className="patient-search-loading">
                <i className="fa fa-spinner spin" /> Loading. Please wait...
            </div>;
        }

        if (error) {
            return <p className="text-danger">Error: {error}</p>;
        }

        const searchHeader = (
            <div className="panel-default">
                <div className="panel-heading" style={{ padding: "5px 15px" }}>
                    <div className="row d-flex align-items-center">
                        <div className="col-xs-4">
                            <b className="text-primary">
                                <i className="fa fa-address-card-o" /> Roles
                            </b>
                        </div>
                        <div className="col-xs-8">
                            <div className="row">
                                <div className="col-md-3 pull-right text-right">
                                    <button
                                        className="btn btn-primary btn-sm"
                                        onClick={() => this.handleSidebar(true, "New Role", "group")}
                                    >
                                        <i className="fa fa-plus" />
                                        &nbsp;New Role
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        if (!rolesList || rolesList.length === 0) {
            return (
                <>
                    {searchHeader}
                    <p>No data available.</p>
                </>
            );
        }

        return (
            <>
                <div className="tab-content-wrapper" style={{ marginBottom: "2.5rem" }}>
                    {searchHeader}
                    <div className="panel-default">

                        <div className="table-responsive">
                            <table className="table table-condensed table-hover table-striped table-bordered">
                                <thead>
                                    <tr>
                                        <th>Role Name</th>
                                        <th className="text-center">All</th>
                                        {APP_TAB_PERMISSIONS.map((p) => (
                                            <th key={p.id} className="text-center">{p.name}</th>
                                        ))}
                                        <th className="text-center"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.renderRolesListRows()}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    saveRolePermissions = async (role, index) => {
        console.log("Saving role permissions:", role, index);
        try {
            const response = await postResource({
                url: `${this.props.settings.server.baseUrl}/usermanagement/group/${role.groupName}/scopes`,
                data: {
                    scopes: role.permissions
                },
                dataType: "text"
            });

            // After saving → disable save button again
            const rolesList = [...this.state.rolesList];
            rolesList[index].isDirty = false;

            this.setState({ rolesList });

            // alert("Role updated successfully!");

        } catch (e) {
            console.error(e);
            alert("Failed to update role");
        }
    };

    renderRolesListRows() {
        const { rolesList } = this.state;

        if (!rolesList || rolesList.length === 0) {
            return (
                <tr>
                    <td colSpan={2 + APP_TAB_PERMISSION_IDS.length} className="text-center">No records found</td>
                </tr>
            );
        }

        return rolesList.map((role, index) => {

            // ✅ Check if this role is CLRAgency
            const isCLRAgency = role?.groupName === "AgencyUser";
            let roleName = "";

            switch (role?.groupName) {
                case "AgencyUser":
                    roleName = "Agency User";
                    break;
                case "CareManager":
                    roleName = "Care Manager";
                    break;
                default:
                    role?.groupName
                    break;
            }

            return (
                <tr key={index}>
                    <td>{roleName || role?.groupName}</td>

                    {/* ✅ ALL Checkbox */}
                    <td className="text-center">
                        <input
                            type="checkbox"
                            checked={role?.permissions.includes("all")}
                            disabled={isCLRAgency}  // ✅ Disable ALL for CLRAgency
                            onChange={() =>
                                this.handlePermissionClick(role, "all", index)
                            }
                        />
                    </td>

                    {/* ✅ INDIVIDUAL PERMISSIONS */}
                    {APP_TAB_PERMISSION_IDS.map((p) => {
                        const disableCheckbox = isCLRAgency;

                        return (
                            <td key={p} className="text-center">
                                <input
                                    type="checkbox"
                                    checked={role?.permissions.includes(p)}
                                    disabled={disableCheckbox}
                                    onChange={() =>
                                        this.handlePermissionClick(role, p, index)
                                    }
                                />
                            </td>
                        );
                    })}

                    {/* ✅ SAVE ICON */}
                    <td className="text-center">
                        <span
                            className={role.isDirty ? "text-primary" : "text-muted"}
                            style={{
                                cursor: role.isDirty ? "pointer" : "not-allowed",
                                opacity: role.isDirty ? 1 : 0.5
                            }}
                            onClick={() => {
                                if (role.isDirty) {
                                    this.saveRolePermissions(role, index);
                                }
                            }}
                        >
                            <i className="fa fa-save"></i>
                        </span>
                    </td>
                </tr>
            );
        });
    }


}

export default connect(state => state)(withRouter(UserManagement));
